export const EXTERNAL_LINKS = {
  SUPPORT_EMAIL: 'mailto:support@piloteer.ai',
  PILOTEER_COMMANDER_DOWNLOAD: 'https://updates.piloteer.ai',
};
